import { CatalogueConfig } from '@domgen/dgx-fe-catalogue';
import { AppConfig } from '../../models/config/app-config.type';

export const catalogueConfigFactory = (config: AppConfig): CatalogueConfig => ({
  //applianceModelApi doesn't have a base URL, and doesn't apply to anything in US Reg
  applianceModelApi: config.applianceModelApi,
  basketApi: config.applianceLookupUrlBase,
  catalogueApi: config.catalogueApi,
});
